import { ErrorBoundary as SharedErrorBoundary } from "@mobility-item-page/client";
import type { ErrorInfo, ReactNode } from "react";

interface ErrorBoundaryProps {
  children?: ReactNode;
  helpCenter: string;
}

const ErrorBoundary = ({ children, helpCenter }: ErrorBoundaryProps) => {
  const onError = (error: Error, errorInfo: ErrorInfo) => {
    const crashError = new Error(`CLIENT_SIDE_CRASH: ${error.message}`);
    crashError.stack = error.stack;
    crashError.name = error.name;

    if (typeof window !== "undefined" && window.TrackJS) {
      window.TrackJS.track(crashError);
    }

    console.error("Uncaught error:", error, errorInfo);
  };

  return (
    <SharedErrorBoundary helpCenter={helpCenter} onError={onError}>
      {children}
    </SharedErrorBoundary>
  );
};

export default ErrorBoundary;
